<template>
    <div>
        <span class="currency">1 {{ currency }}</span>
        <b-button-group>
            <b-button
                    :class="{'active': markupType === null}"
                    @click="doSubmit(null, null)"
            >
                BNR <span class="value-tooltip">{{ parseFloat(value).toFixed(4) }}</span>
            </b-button>

            <b-button
                    :class="{'active': markupType === 'PERCENTAGE' && markup == 1}"
                    @click="doSubmit('PERCENTAGE', 1)"
            >
                BNR+1% <span class="value-tooltip">{{ (value * (1.01)).toFixed(4) }}</span>
            </b-button>

            <b-button
                    :class="{'active': markupType === 'PERCENTAGE' && markup == 3}"
                    @click="doSubmit('PERCENTAGE', 3)"
            >
                BNR+3% <span class="value-tooltip">{{ (value * (1.03)).toFixed(4) }}</span>
            </b-button>

            <b-button :class="{'active': isManual}" @click="showModal">
                Manual <span class="value-tooltip" v-if="isManual">{{ getManualString }}</span>
            </b-button>
        </b-button-group>

        <b-modal ref="my-modal" hide-footer title="Alege tipul de adaos">
            <div role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-1 variant="info" @click="onReset">Valoare exactă</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>Setează cursul de schimb cu o valoare exactă</b-card-text>
                            <b-form @submit="onSubmit" inline class="justify-content-between">
                                <b-input-group size="sm" :prepend="'1 ' + currency + ' ='" >
                                    <b-form-input
                                        size="sm"
                                        type="number"
                                        step="0.01"
                                        placeholder="Introdu o sumă"
                                        v-model="exact"
                                        required>
                                    </b-form-input>
                                </b-input-group>

                                <b-button type="submit" variant="success" size="sm">
                                    Salvează <span class="value-tooltip" v-if="exact">({{ parseFloat(exact).toFixed(4) }})</span>
                                </b-button>
                            </b-form>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-2 variant="info" @click="onReset">Procentaj</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>Modifică cursul BNR cu un procentaj</b-card-text>
                            <b-form @submit="onSubmit" inline class="justify-content-between">
                                <b-input-group size="sm" append="%" >
                                    <b-form-input
                                            size="sm"
                                            type="number"
                                            step="0.01"
                                            placeholder="Introdu un procentaj"
                                            v-model="percentage"
                                            required>
                                    </b-form-input>
                                </b-input-group>

                                <b-button type="submit" variant="success" size="sm">
                                    Salvează <span class="value-tooltip" v-if="percentage">({{ (parseFloat(value) * (100 + parseFloat(this.percentage)) / 100).toFixed(4) }})</span>
                                </b-button>
                            </b-form>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-3 variant="info" @click="onReset">Adaos fix</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>Adaugă o sumă fixă la cursul BNR</b-card-text>
                            <b-form @submit="onSubmit" inline class="justify-content-between">
                                <b-input-group size="sm" :prepend="parseFloat(value).toFixed(4) + ' +'" >
                                    <b-form-input
                                            size="sm"
                                            type="number"
                                            step="0.01"
                                            placeholder="Introdu o sumă"
                                            v-model="absolute"
                                            required>
                                    </b-form-input>
                                </b-input-group>

                                <b-button type="submit" variant="success" size="sm">
                                    Salvează <span class="value-tooltip" v-if="absolute">({{ (parseFloat(value) + parseFloat(this.absolute)).toFixed(4) }})</span>
                                </b-button>
                            </b-form>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Anulare</b-button>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                percentage: null,
                absolute: null,
                exact: null,
            }
        },
        name: "CurrencyPicker",
        methods: {
            showModal() {
                this.$refs['my-modal'].show()
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            onReset(evt) {
                if(evt) evt.preventDefault()

                this.percentage = null;
                this.absolute = null;
                this.exact = null;
            },
            onSubmit(evt) {
                evt.preventDefault()

                if(this.percentage)
                    this.doSubmit('PERCENTAGE', this.percentage)
                else if(this.absolute)
                    this.doSubmit('ABSOLUTE', this.absolute)
                else if(this.exact)
                    this.doSubmit('EXACT', this.exact)
                else
                    this.doSubmit(null, null)

                this.onReset()
                this.hideModal()
            },
            doSubmit(markupType, markup) {
                this.$emit('selected', {
                    currency: this.currency,
                    markupType,
                    markup,
                });
            }
        },
        props: [
            'currency',
            'value',
            'markupType',
            'markup'
        ],
        computed: {
            isManual() {
                if(this.markupType === null) return false;
                else if(this.markupType === "PERCENTAGE" && (this.markup == 1 || this.markup == 3)) return false;

                return true;
            },
            getManualString() {
                if(!this.isManual) return null;

                if(this.markupType === "PERCENTAGE") return `+${this.markup}%`;
                if(this.markupType === "ABSOLUTE") return `+${this.markup} RON`;
                if(this.markupType === "EXACT") return `=${this.markup} RON`;

                return null;
            }
        }
    }
</script>

<style scoped>
    .currency {
        font-weight: 600;
        margin-right: 10px;
        font-size: 1.2rem;
    }

    .value-tooltip {
        color: #ffffff8f;
        font-size: small;
    }
</style>